(function ($) {
    VIV.behaviours.tableFilter = (function () {

        const attach = function (context) {
            const blocks = context.querySelectorAll('.tableFilter');

            if (blocks.length === 0) {
                return;
            }

            blocks.forEach(block => init(block, context));
        };

        /**
         * Initialise the table filter
         *
         * @param block
         * @param context
         */
        const init = function (block, context) {
            const filterColumn = block.getAttribute('data-filter-column');
            if (!filterColumn || parseInt(filterColumn) <= 0) {
                console.log('No filter column specified');
                return;
            }


            const table = block.parentElement.querySelector('.table');
            if (!table) {
                console.log('No table found');
                return;
            }

            const selectWrapper = block.querySelector('.tableFilter__selectWrapper');
            if (!selectWrapper) {
                console.log('No select wrapper found');
                return;
            }


            const rows = table.querySelectorAll('tbody tr');
            if (rows.length === 0) {
                console.log('No rows found');
                return;
            }

            block.style.display = 'flex';

            // Add filter input
            const values = [];
            rows.forEach(row => {
                const value = row.querySelector(`td:nth-child(${filterColumn}) .table__value`).innerText.trim();
                if (!values.includes(value)) {
                    values.push(value);
                }
            });

            // Sort values
            //values.sort();

            const selectLabelWrapper = block.querySelector('.tableFilter__selectLabel');
            const selectLabel = table.querySelector('thead th:nth-child(' + filterColumn + ')').innerText.trim();
            if (selectLabelWrapper && selectLabel) {
                selectLabelWrapper.innerHTML = selectLabel;
            }

            const select = createSelectWithValues(values);
            selectWrapper.appendChild(select);

            // Hide filterColumn in table
            table.querySelectorAll('th:nth-child(' + filterColumn + '), td:nth-child(' + filterColumn + ')').forEach(td => td.style.display = 'none');

            // Add event listener
            $(select).on('change', function (e) {
                const value = e.target.value;
                rows.forEach(row => {
                    const cellValue = row.querySelector(`td:nth-child(${filterColumn}) .table__value`).innerText.trim();
                    row.classList.toggle('table__row--hidden', cellValue !== value && value !== 'all');
                });
                addOddEventClassesToTableRows(table);
            });

            selectFirstOption(select);

            VIV.behaviours.form.initSelect(block);
        };

        const addOddEventClassesToTableRows = function (table) {
            const filterRows = table.querySelectorAll('tbody tr:not(.table__row--hidden)');
            console.log(filterRows);
            filterRows.forEach((row, index) => {
                if (index % 2 === 0) {
                    row.classList.add('table__row--even');
                } else {
                    row.classList.add('table__row--odd');
                }
            });
        }

        const selectFirstOption = function (select) {
            const options = select.querySelectorAll('option');
            if (options.length > 0) {
                options[0].selected = true;
            }
            $(select).trigger('change');

        }

        /**
         * Create a select element with the given values
         *
         * @param values
         * @param label
         * @returns {HTMLSelectElement}
         */
        const createSelectWithValues = function (values) {
            // Create select
            const select = document.createElement('select');

            // Add options
            values.forEach(value => {
                const option = document.createElement('option');
                option.value = value;
                option.innerText = value;
                select.appendChild(option);
            });
            return select;
        }

        return {
            attach: attach
        }
    })();
})(jQuery)
